<template>
  <div class="steps">
    <div class="step-item" v-bind:class="{'is-completed':(coutStep > 0)?true:false,'is-hidden-mobile':(coutStep !== 0)?true:false,'is-active':coutStep===0}">
      <div class="step-marker">1<span class="is-hidden-tablet">/3</span></div>
      <div class="step-details">
        <p class="step-title">{{ $t("userDetail.userInformationHeader") }}</p>
      </div>
    </div>
    <div class="step-item" v-bind:class="{'is-completed':(coutStep > 1)?true:false,'is-hidden-mobile':(coutStep !== 1)?true:false,'is-active':coutStep===1}">
      <div class="step-marker">2<span class="is-hidden-tablet">/3</span></div>
      <div class="step-details">
        <p class="step-title">{{ $t("userDetail.departmentHeader") }}</p>
      </div>
    </div>
    <div class="step-item is-finish" :class="{'is-hidden-mobile':(coutStep !== 2)?true:false,'is-active':coutStep===2}">
      <div class="step-marker">3<span class="is-hidden-tablet">/3</span></div>
      <div class="step-details">
        <p class="step-title">{{ $t("userDetail.confirmation") }}</p>
      </div>
    </div>
    <div class="steps-content">
      <div class="level">
        <div class="level-left">
          <h4 class="title has-text-left is-4">{{ currentStep }}</h4>
        </div>
      </div>
      <div class="step-content has-text-centered is-active">
        <div class="boxFormSigUpTitle">
          <p class="is-size-4 has-text-weight-semibold label-Left">{{ $t("userDetail.userInformationHeader") }}</p>
        </div>
        <section>
          <div class="columns m-h-auto">
            
            <div class="column is-6">
              <b-field
                :label="$t('userDetail.coordinatorEmail')"
                :type="$v.email.$error == true ? 'is-danger': ''"
                class="label-Left"
              >
                <b-input
                  disabled
                  :placeholder="$t('userDetail.placeholderEmail')"
                  type="email"
                  icon-pack="fas"
                  icon="envelope"
                  v-model="email"
                  @input="$v.email.$touch()"
                ></b-input>
              </b-field>
              
            </div>
          </div>
          <div class="columns m-h-auto">
            <div class="column">
              <b-field
              :label="$t('userDetail.labelPassword')"
                :type="$v.password.$error == true ? 'is-danger': ''"
                :message="$v.password.$error == true ? 'Password must have at least 8 letters.' : ''"
                class="label-Left reveal"
              >
                <b-input

                  :placeholder="$t('userDetail.placeholderPassword')"
                  @input="$v.password.$touch()"
                  type="password"
                  password-reveal
                  icon-pack="mdi"
                  icon="lock"
                  v-model="password"
                ></b-input>
              </b-field>
            </div>

            <div class="column">
              <b-field
               :label="$t('userDetail.labelConfirmPassword')"
                class="label-Left reveal"
                :type="$v.repassword.$error == true ? 'is-danger': ''"
                :message="$v.repassword.$error == true ? 'Password not match' : ''"
              >
                <b-input
                  :placeholder="$t('userDetail.placeholderConfirmPassword')"
                  type="password"
                  password-reveal
                  icon-pack="mdi"
                  icon="lock"
                  v-model="repassword"
                  @input="$v.repassword.$touch()"
                ></b-input>
              </b-field>
            </div>
          </div>
        </section>
      </div>
      <div class="step-content has-text-centered">
        <div class="boxFormSigUpTitle is-justify-center is-align-center is-flex-medium is-flex-row">
          <div class="is-justify-center is-align-center is-flex-large is-flex-row icon is-medium">
            <p class="is-size-4 has-text-weight-normal th label-Left">{{ $t("userDetail.personalHeader") }}</p>
          </div>
          <div  class="has-text-right is-margin-y-ss">
            <a class="label-right backpage-color textAndiconBackInformation" @click="backStep(0)">
            <i class="fas fa-arrow-left  is-margin-right-sm"></i>{{ $t("userDetail.backToUserInfomation") }}</a>
          </div>
        </div>
        

          <hr class="hrPadding"> -->
          <div class="columns m-h-auto">
            <div class="column is-6" v-if="filterOrganizeName.length > 0">
              <b-field  :label="$t('userDetail.labelSelectDepartment')" class="label-Left">
                <b-select :placeholder="$t('userDetail.placeholderSelectDepartment')" expanded disabled v-model="scienceParkId">
                <option
                class="th has-text-left"
                
                  v-for="option in filterOrganizeName"
                  :value="option._id"
                  :key="option._id">
                  {{ option.name }}
                </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="$t('userDetail.profileImage')" class="label-Left">
                <b-upload v-model="profilePic" @input="checkProfile()" drag-drop>
                  <section class="section">
                    <div
                      class="content has-text-centered is-justify-start is-align-start is-flex-row boxUpload"
                    >
                      <b-icon
                        pack="fas"
                        icon="sync-alt"
                        ref="file"
                        custom-class="fa-cloud-upload-alt"
                        class="confirm-icon-color icon-upload"
                      ></b-icon>
                      <p
                        v-if="profileName != ''"
                        class="is-size-8 text-upload is-margin-right-m"
                        ref="fileLabel"
                      >
                        <span class="is-hidden-mobile">{{profileName | snippetSmall}}</span>
                        <span class="is-hidden-tablet">{{profileName | snippetMobile}}</span>
                      </p>
                      <p v-else class="is-size-8 text-upload icon-upload" ref="fileLabel">
                        <span class="placeholder-th">{{$t('userDetail.placeholderUploadPicture')}}</span>
                      </p>
                      <a class="button btnUploadFile is-size-7">{{$t('message.chooseFile')}}</a>
                    </div>
                  </section>
                </b-upload>
              </b-field>
              <div v-if="profileupload !== ''">
                <span v-if="profileupload == 0" class="is-size-7 th has-text-danger">{{$t('form.statusUploadFileFailed')}}</span>
                <span v-if="profileupload == 1" class="is-size-7 th has-text-success">{{$t('form.statusUploadFileSuccessfully')}}</span>
                <span v-if="profileupload == 2" class="is-size-7 th">{{$t('form.statusUploadFileUploading')}}....</span>
              </div>
            </div>
          </div>
          <div class="columns m-h-auto">
            <div class="column">
              <div class="columns m-h-auto">
                <div class="column is-4">
                  <p class="is-size-6 has-text-left has-text-weight-semibold">{{$t('userDetail.coordinatorNameTitle')}}</p>
                  <b-dropdown
                    @change="$v.titleName.$touch()"
                    class="dropdown-flex is-padding-sm-y"
                    position="is-bottom-left"
                    v-model="titleName"
                  >
                    <button
                      class="button width-max"
                      :class="{'form-error-button':$v.titleName.$error}"
                      slot="trigger"
                      type="button"
                    >
                      <template v-if="titleName">
                        <span class="icon is-medium">
                          <i class="fas fa-lg fa-pen has-text-grey-lighter"></i>
                        </span>
                        <div
                          v-for="item in dataPrefix"
                          :key="item.id"
                          class="is-align-start is-justify-start is-flex-medium is-flex-row is-margin-left-s"
                        >
                          <p
                            class="has-color-drak-bold is-size-6 th"
                            v-if="titleName == item.name"
                          >{{ $i18n.locale === 'th' ?item.name:item.nameEN }}</p>
                        </div>
                        <span class="icon is-small">
                          <i class="fas fa-angle-down has-text-grey-lighter" aria-hidden="true"></i>
                        </span>
                      </template>
                      <template
                        v-else
                        class="is-align-start is-justify-center is-flex-medium is-flex-row"
                      >
                        <span class="icon is-medium">
                          <i class="fas fa-lg fa-pen has-text-grey-lighter"></i>
                        </span>
                        <div
                          class="is-align-start is-justify-start is-flex-medium is-flex-row is-margin-left-s"
                        >
                          <p class="placeholder-th">{{$t('userDetail.placeholderPrefix')}}</p>
                        </div>
                        <span class="icon is-small">
                          <i class="fas fa-angle-down has-text-grey-lighter" aria-hidden="true"></i>
                        </span>
                      </template>
                    </button>

                    <b-dropdown-item
                      v-for="item in dataPrefix"
                      :key="item.id"
                      :value="item.name"
                      class="is-align-center is-flex-medium is-flex-row"
                    >
                      <p class="has-text-grey-dark th">{{ $i18n.locale === 'th' ?item.name:item.nameEN }}</p>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="column">
                  <b-field
                    :label="$t('userDetail.labelName')"
                    class="label-Left"
                    :type="$v.name.$error == true ? 'is-danger': ''"
                  >
                    <b-input
                      :placeholder="$t('userDetail.placeholderName')"
                      type="text"
                      icon-pack="fas"
                      @input="$v.name.$touch()"
                      icon="pen"
                      v-model="name"
                    ></b-input>
                  </b-field>
                </div>
              </div>
            </div>
            <div class="column">
              <b-field
               :label="$t('userDetail.labeLastName')"
                :type="$v.surname.$error == true ? 'is-danger': ''"
                class="label-Left"
              >
                <b-input
  
                   :placeholder="$t('userDetail.placeholderLastName')"
                  type="text"
                  icon-pack="fas"
                  @input="$v.surname.$touch()"
                  icon="pen"
                  v-model="surname"
                ></b-input>
              </b-field>
            </div>
          </div>

          <div class="columns m-h-auto">
            <div class="column">
              <b-field
              
                :label="$t('userDetail.labePosition')"
                :type="$v.position.$error == true ? 'is-danger': ''"
                class="label-Left"
              >
                <b-input
                 :placeholder="$t('userDetail.placeholderPosition')"
                  type="text"
                  icon-pack="fas"
                  @input="$v.position.$touch()"
                  icon="user"
                  v-model="position"
                ></b-input>
              </b-field>
            </div>
            <div class="column">
              <b-field
             
                :label="$t('userDetail.modalEditProfileTelephoneNumber')"
                :type="$v.telephoneNumber.$error == true ? 'is-danger': ''"
                class="label-Left"
              >
                <b-input
                  :placeholder="$t('userDetail.placeholderProfileDepartmentPhone')"
                  type="text"
                  icon-pack="fas"
                  maxlength="10"
                  @input="$v.telephoneNumber.$touch()"
                  icon="phone"
                  v-model="telephoneNumber"
                ></b-input>
              </b-field>
            </div>
          </div>

          <div class="columns m-h-auto has-text-right">
 
        </div>
        </section>
      </div>
      <div class="step-content has-text-centered">
        <div class="boxFormSigUpTitleConfirmation">
          <p class="is-size-4 has-text-weight-semibold label-Left">{{$t('userDetail.confirmation')}}</p>
        </div>
        <div>
          <div class="level is-marginless">
            <div>
              <p class="is-size-6 has-text-weight-semibold label-Left paddingTop">{{$t('userDetail.userInformationHeader')}}</p>
            </div>
            <div class="has-text-right-mobile">
              <a @click="backStep(0)" class="is-size-6 has-text-weight-semibold confirm-icon-color editeColor"><i class="fas fa-lg fa-pen is-margin-right-sm"></i>{{$t('message.edit')}}</a>
            </div>
          </div>
          <hr class="line-title marginLine">
          <div class="mg-y-15 has-text-left level-mobile">
            <p class="is-size-6 has-text-weight-semibold is-flex is-align-center " :class="{'is-justify-center':widthMax < 768}">
              <b-icon pack="fas" icon="sync-alt" custom-class="fa-envelope" class="confirm-icon-color mg-r-5"></b-icon>
               {{$t('userDetail.coordinatorEmail')}}:<span class="th confirm-text-color confirm-padding-left fw-100 is-hidden-mobile">{{email}}</span>
            </p>
            <p class="is-size-6 th confirm-text-color has-text-centered fw-100 is-hidden-tablet">{{email}}</p>
          </div>
          <div class="mg-y-15 has-text-left level-mobile">
            <p class="is-size-6 has-text-weight-semibold is-flex is-align-center " :class="{'is-justify-center':widthMax < 768}">
              <b-icon pack="fas" icon="sync-alt" custom-class="fa-lock" class="confirm-icon-color mg-r-5"></b-icon>
              {{$t('userDetail.labelPassword')}}: <i class="fas fa-circle is-margin-left-sm is-hidden-mobile" v-for="(item,index) in checkPassHide(password)" :key="index"></i>
            </p>
            <div class="is-hidden-tablet has-text-centered">
              <i class="fas fa-circle is-margin-left-sm" v-for="(item,index) in checkPassHide(password)" :key="index"></i>
            </div>
          </div>
        </div>
       
        <div class="level is-marginless">
          <div>
            <p
              class="is-size-6 has-text-weight-semibold label-Left paddingTop"
            >{{$t('userDetail.personalHeader')}}</p>
          </div>
          <div class="has-text-right-mobile">
            <a
              @click="backStep(1)"
              class="is-size-6 has-text-weight-semibold confirm-icon-color editeColor"
            >
              <i class="fas fa-lg fa-pen is-margin-right-sm"></i>{{$t('message.edit')}}
            </a>
          </div>
        </div>
        <hr class="line-title marginLine">
        <div class="columns m-h-auto pd-y-20">
          <div v-if="coutStep === 2"  class="column is-1 is-justify-center is-align-center is-flex">
            <figure class="image imgName is-marginless">
              <img class="is-rounded" v-if="profilePic != ''" :src="imgUrl+profileName">
              <img
                class="is-rounded"
                v-else
                src="https://bulma.io/images/placeholders/64x64.png"
                alt="Placeholder image"
              >
            </figure>
          </div>
          <div class="column">
            <div class="columns m-h-auto is-flex-wrap ">
              <div class="column is-12 has-text-left level-mobile">
                <p class="is-size-12 has-text-weight-semibold is-flex is-align-center " :class="{'is-justify-center':widthMax < 768}">
                  <b-icon pack="fas" icon="sync-alt" custom-class="fa-pen" class="confirm-icon-color mg-r-5"></b-icon>
                  {{$t('userDetail.labelSelectDepartment')}}: <span class="th confirm-text-color confirm-padding-left fw-100 is-hidden-mobile">{{getNamerScienPark(scienceParkId)}}</span>
                </p>
                <p class="is-size-6 th confirm-text-color has-text-centered fw-100 is-hidden-tablet">{{getNamerScienPark(scienceParkId)}}</p>
              </div>
              <div class="column is-6 has-text-left level-mobile">
                <p class="is-size-6 has-text-weight-semibold is-flex is-align-center " :class="{'is-justify-center':widthMax < 768}">
                  <b-icon pack="fas" icon="sync-alt" custom-class="fa-pen" class="confirm-icon-color mg-r-5"></b-icon>
                  {{$t('userDetail.labelName')}}:<span class="th confirm-text-color confirm-padding-left fw-100 is-hidden-mobile">{{titleName}} {{name | snippetSmallDoc}}</span>
                </p>
                <p class="is-size-6 th confirm-text-color has-text-centered fw-100 is-hidden-tablet">{{titleName}} {{name | snippetSmallDoc}}</p>
              </div>
              <div class="column is-6 has-text-left level-mobile">
                <p class="is-size-6 has-text-weight-semibold is-flex is-align-center" :class="{'is-justify-center':widthMax < 768}">
                  <b-icon pack="fas" icon="sync-alt" custom-class="fa-pen" class="confirm-icon-color mg-r-5"></b-icon>
                  {{$t('userDetail.labeLastName')}}:<span class="th confirm-text-color confirm-padding-left fw-100 is-hidden-mobile">{{surname}}</span>
                </p>
                <P class="is-size-6 th confirm-text-color has-text-centered fw-100 is-hidden-tablet">{{surname}}</P>
              </div>
            </div>
            <div class="columns is-flex-wrap m-h-auto ">
              <div class="column is-6 has-text-left level-mobile">
                <p class="is-size-6 has-text-weight-semibold is-flex is-align-center " :class="{'is-justify-center':widthMax < 768}">
                  <b-icon pack="fas" icon="sync-alt" custom-class="fa-user" class="confirm-icon-color mg-r-5"></b-icon>
                   {{$t('userDetail.labePosition')}}:<span class="th confirm-text-color confirm-padding-left fw-100 is-hidden-mobile">{{position | snippetSmallDoc}}</span>
                </p>
                <p class="is-size-6 th confirm-text-color has-text-centered fw-100 is-hidden-tablet">{{position}}</p>
              </div>
              <div class="column is-6 has-text-left level-mobile">
                <p class="is-size-6 has-text-weight-semibold is-flex is-align-center" :class="{'is-justify-center':widthMax < 768}">
                  <b-icon pack="fas" icon="sync-alt" custom-class="fa-phone" class="confirm-icon-color mg-r-5"></b-icon>
                   {{$t('userDetail.coordinatorTelephone')}}:<span class="th confirm-text-color confirm-padding-left fw-100 is-hidden-mobile">{{telephoneNumber}}</span>
                </p>
                <P class="is-size-6 th confirm-text-color has-text-centered fw-100 is-hidden-tablet">{{telephoneNumber}}</P>
              </div>
            </div>
          </div>
        </div>
        <div class="is-justify-center is-align-center is-flex">
          <div class="steps-action boxBtnNext confirm-margin-bottom">
            <a @click="(loadingSignup)?null:onSubmit()"  class="button is-light is-btn-link has-text-centered">Next</a>
          </div>
        </div>
      </div>
      <div class="step-content has-text-centered is-success">
        <svg
          width="120px"
          height="120px"
          class="iconSucces"
          viewBox="0 0 120 120"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="check-group" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <circle id="filled-circle" fill="#00a79d" cx="66.5" cy="66.5" r="44"></circle>
            <circle id="white-circle" fill="#FFFFFF" cx="66.5" cy="66.5" r="45"></circle>
            <circle id="outline" stroke="#00a79d" stroke-width="5" cx="66.5" cy="66.5" r="45"></circle>
            <polyline id="check" stroke="#FFFFFF" stroke-width="5" points="41 70 56 85 92 49"></polyline>
          </g>
        </svg>

        <!-- <i class="fas fa-check-circle fa-6x"></i> -->
        <h1 class="is-1">{{ $t("userDetail.signUpSuccessTitle") }}!</h1>
        <br>
        <router-link to="/signin" class="button is-large btnSigIn">{{ $t("signin.signinButton") }}</router-link>
        <p class="subTitleStart">{{ $t("userDetail.signUpSuccessManaging") }}</p>
      </div>
    </div>
    <div class="is-justify-center is-align-center is-flex-medium is-flex-column pd-10 mg-t-40">
      <p v-if="coutStep === 0" class="th is-size-6 ">
        <b-checkbox size="is-small" type="is-black" v-model="confirmTC"></b-checkbox>{{ $t("signin.accept1") }}   
        <a href="/terms-of-use/admin" target ="_blank">{{ $t("signin.termsService") }}</a> {{ $t("signin.and") }}
        <a href="/privacy-policy/admin" target ="_blank">{{ $t("signin.privacyPolicy") }}</a>
      </p>
      <p v-if="agree" style="color:#ff3860">{{ $t("signin.accept2") }}</p>
      
    </div>
    <div class="steps-actions">
      <div class="steps-action is-marginless" :class="{'boxBtnNextBtNot':coutStep===0}">
        <a @click="nextStep()" class="button is-light is-btn-link">{{ $t("message.btnNext") }}</a>
      </div>
    </div>
    <b-loading :active.sync="loadingSignup" ></b-loading>
    <div class="is-justify-center is-align-center is-flex-medium is-flex-column pd-10">
      <p v-if="coutStep === 0" class="th is-size-6 mg-t-20">{{ $t("signin.footer1") }}
        <a @click="$router.push('/signin')">{{
          $t("signin.signinButton")
        }}</a> {{ $t("signin.footer2") }}
      </p>
      <p v-if="coutStep === 0" >
        <span class="th is-size-6">{{ $t("signin.version") }}</span>
      </p>
    </div>
  </div>
</template>
<script>
import { checkPassHide } from "../service/password";
import { HTTP } from "../axios.js";
import { mapGetters } from "vuex";
import jwt from "jsonwebtoken";
import {
  required,
  minLength,
  sameAs,
  between,
  numeric,
  email,
  helpers,
} from "vuelidate/lib/validators";

const text = helpers.regex("text", /^[a-zA-Zก-๙ ]*$/);

export default {
  validations: {
    email: {
      required,
      email,
    },

    password: {
      required,
      minLength: minLength(8),
    },
    repassword: {
      sameAsPassword: sameAs("password"),
    },
    departmentName: {
      required,
    },
    organizeName: {
      required,
    },
    sciencePark: {
      required,
    },
    name: {
      required,
      text,
    },
    surname: {
      required,
      text,
    },
    position: {
      required,
    },
    telephoneBusinessTeam: {
      numeric,
      required,
      minLength: minLength(9),
    },
    telephoneNumber: {
      numeric,
      required,
      minLength: minLength(10),
    },
    titleName: {
      required,
    },
  },
  props: ["stepIndex"],
  data() {
    return {
      sciencePark: "",
      selected: null,
      dataDepartment: [],
      dataOrganization: [],
      departmentName: "",
      batchId: "",
      userLevel: 85,
      name: "",
      surname: "",
      profilePic: [],
      email: "",
      password: "",
      repassword: "",
      position: "",
      telephoneNumber: "",
      telephoneBusinessTeam: "",
      organizeName: "",
      organizeLogo: [],
      file: "",
      currentStep: "",
      regisId: this.$route.params.id,
      token: "",
      fileUrl: "",
      tokenAuth: "",
      profileupload: "",
      logoupload: 1,
      profileName: "",
      logoName: "",
      coutStep: 0,
      titleName: "",
      loadingSignup: false,
      widthMax: window.innerWidth,
      confirmTC: false,
      scienceParkId: null,
      isConnected: false,
      adminId: null,
      agree: null,
    };
  },
  async created() {
    this.$store.commit("setSpaPage", null);
    this.imgUrl = process.env.VUE_APP_IMAGE_URL;

    const SECRET = "T)JACKSAD(FO2ot&NAVBL*O+CKBUST$E%R";
    var token = jwt.verify(this.regisId, SECRET);
    // console.log('jtw',token)

    this.getDepartment();
    this.getOrganization();
    this.scienceParkId = token.scienceParkId;
    this.email = token.emailBoard;
  },
  watch: {
    profilePic() {
      if (this.profilePic) {
        this.checkProfile();
      }
    },
    organizeLogo() {
      if (this.organizeLogo) {
        this.checkLogo();
      }
    },
  },
  computed: {
    underAdmin() {
      const SECRET = "T)JACKSAD(FO2ot&NAVBL*O+CKBUST$E%R";
      var token = jwt.verify(this.regisId, SECRET);
      // console.log('jtw',token)

      return token;
    },
    filterOrganizeName() {
      return this.dataOrganization.filter((option) => {
        return this.underAdmin.underId === option.underId;
      });
    },
    filterDepartmentName() {
      return this.dataDepartment.filter((option) => {
        return (
          typeof option.name !== "undefined" &&
          option.name.toString().toLowerCase().indexOf(this.departmentName) >= 0
        );
      });
    },
    dataPrefix() {
      return this.$store.state.prefix;
    },
  },
  sockets: {},
  methods: {
    getNamerScienPark(id) {
      let data = this.dataOrganization.filter((search) => {
        return search._id == id;
      });
      if (data.length > 0) {
        return data[0].name;
      } else {
        return "";
      }
    },
    getOrganization() {
      HTTP.post("/get/all/science/park").then((res) => {
        // console.log('/get/all/science/park',res)
        this.dataOrganization = res.data.obj;
      });
    },
    getDepartment() {
      HTTP.post("api/get/all/under").then((res) => {
        this.dataDepartment = res.data.obj;
      });
    },
    backStep(index) {
      this.stepIndex.activate_step(index);
      switch (index) {
        case 0:
          this.coutStep = 0;
          break;
        case 1:
          this.coutStep = 1;
          break;
        case 2:
          this.coutStep = 2;
          break;
        default:
          break;
      }
    },
    nextStep() {
      switch (this.coutStep) {
        case 0:
          this.$v.email.$touch();
          this.$v.password.$touch();
          this.$v.repassword.$touch();

          if (
            this.$v.email.$invalid ||
            this.$v.password.$invalid ||
            this.$v.repassword.$invalid
          ) {
          } else {
            if (this.confirmTC) {
              const data = {
                email: this.email,
              };

              HTTP.post("api/user/check/email", data)
                .then((res) => {
                  // console.log("api/user/check/email", res);
                  if (res.data.success) {
                    this.agree = false;
                    this.stepIndex.activate_step(1);
                    this.coutStep = 1;
                  } else {
                    alert("อีเมล์นี้ถูกใช้งานแล้ว");
                  }
                })
                .catch((e) => {
                  console.log("api/user/check/email/error", e);
                });
            } else {
              this.agree = true;
              alert(
                "กรุณายอมรับเงื่อนไขการใช้บริการ และ นโยบายความเป็นส่วนตัว"
              );
            }
          }
          break;
        case 1:
          //this.$v.organizeName.$touch();
          this.$v.name.$touch();
          this.$v.surname.$touch();
          this.$v.position.$touch();
          this.$v.telephoneNumber.$touch();
          //this.$v.telephoneBusinessTeam.$touch();
          this.$v.titleName.$touch();

          if (
            this.$v.name.$invalid ||
            this.$v.surname.$invalid ||
            this.$v.position.$invalid ||
            this.$v.telephoneNumber.$invalid ||
            this.$v.titleName.$invalid
          ) {
          } else if (this.logoupload == 1) {
            if (this.profileupload == 1) {
              this.stepIndex.activate_step(2);
              this.coutStep = 2;
            } else {
              alert("กรุณาอัพโหลดรูปโปรไฟล์");
            }
          } else {
            alert("กรุณาอัพโหลดโลโก้บริษัท");
          }

          break;
        default:
          break;
      }
    },
    async checkProfile() {
      const type = this.profilePic.type;
      this.profileupload = 2;
      if (
        type === "image/jpeg" ||
        type === "image/png" ||
        type === "image/gif"
      ) {
        const profile = new FormData();
        profile.append("profileImage", this.profilePic);
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        await HTTP.post("upload/profile", profile, config).then((result) => {
          this.profileName = result.data;
          if (result.data !== "") {
            this.profileupload = 1;
          } else {
            this.profileupload = 0;
          }
        });
      } else {
        this.profilePic = "";
        this.profileupload = 0;
        alert("รูปโปรไฟล์ ระบบไม่รองรับรูปแบบไฟล์");
      }
    },
    async checkLogo() {
      const typeLogo = this.organizeLogo[0].type;
      this.logoupload = 2;
      if (
        typeLogo === "image/jpeg" ||
        typeLogo === "image/png" ||
        typeLogo === "image/gif"
      ) {
        const formData = new FormData();
        formData.append("profileImage", this.organizeLogo[0]);
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        await HTTP.post("upload/profile", formData, config).then((result) => {
          this.logoName = result.data;
          if (result.data !== "") {
            this.logoupload = 1;
          } else {
            this.logoupload = 0;
          }
        });
      } else {
        this.organizeLogo = "";
        this.logoupload = 0;
        alert("โลโก้บริษัท ระบบไม่รองรับรูปแบบไฟล์");
      }
    },
    onSubmit() {
      if (this.profileupload == 1 && this.logoupload == 1) {
        this.loadingSignup = true;
        const data = {
          userLevel: this.userLevel,
          titleName: this.titleName,
          name: this.name,
          surname: this.surname,
          profilePic: this.profileName,
          email: this.email,
          password: this.password,
          repassword: this.repassword,
          position: this.position,
          telephoneNumber: this.telephoneBusinessTeam,
          mobilePhone: this.telephoneNumber,
          organizeName: this.organizeName,
          organizeLogo: this.logoName,
          scienceParkName: this.sciencePark,
          scienceParkId: this.scienceParkId,
          token: this.token,
          adminId: this.underAdmin.adminId,
          underId: this.underAdmin.underId,
          tokenAuth: this.regisId,
          isSpa: false,
        };

        let tmpUser;
        // console.log(data)
        HTTP.defaults.headers.common.Authorization = `Bearer ${data.tokenAuth}`;
        HTTP.post("api/user/check/email", data).then((result) => {
          if (result.data.success) {
            HTTP.post("api/user", data)
              .then((result) => {
                //  console.log('respon add user', res);
                if (result.data.success) {
                  if (res.data.status === "Validation exception") {
                    alert("ลิงค์นี้ถูกใช้งานไปแล้ว");
                  } else {
                    this.sendRealTimeSingUpBoard(this.underAdmin.adminId);
                    this.$router.push("/sign-up/finish/admin");
                  }
                } else {
                  alert("สมัครสมาชิกล้มเหลว กรุณาสมัครใหม่");
                }
                this.loadingSignup = false;
              })
              .catch((e) => {
                alert("ลิงค์นี้ถูกใช้งานไปแล้ว");
                console.log("respon add user error", e);
                this.loadingSignup = false;
              });
          } else {
            this.loadingSignup = false;
            alert(
              "อีเมลนี้ถูกใช้งานแล้ว หรือ ต้องการเข้าร่วม Batch นี้ ให้กด Sign in เพื่อเข้าสู่ระบบ"
            );
          }
        });
      } else {
        alert("กรุณาอัพโหลดรูปโปรไฟล์ และ โลโก้บริษัท");
      }
    },
    sendRealTimeSingUpBoard(id) {
      // console.log('testId',id)
      this.$socket.emit("listNoti", {
        userId: id,
      });
    },
  },
};
</script>

<style>
.boxFormSigUp {
  margin-top: 2rem;
}
.boxFormSigUpTitle {
  margin-top: 4rem;
  margin-bottom: 1.5rem;
}
.boxFormSigUpTitleConfirmation {
  margin-top: 4rem;
  margin-bottom: 0.5rem;
}
.input-w {
  min-width: 30rem !important;
  max-width: 39rem !important;
}
.boxBtnNext {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.is-btn-link {
  height: 3rem !important;
}
.hrPadding {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.paddingTop {
  padding-top: 2.5rem;
}
.section {
  padding-bottom: 0.1rem !important;
  padding-top: 0.1rem !important;
  padding-left: 0.7rem !important;
  padding-right: 0 !important;
}
.boxUpload {
  display: flex !important;
  height: 1.6rem;
  width: 37.5rem;
}
.textAndiconBackInformation {
  font-size: 0.8rem;
}
.backpage-color:hover {
  color: #7619ec !important;
}
.paddingTop {
  padding-top: 1rem;
}
.boxPointPass {
  display: flex !important;
  width: 5rem;
}
.marginLine {
  margin-top: 1.5rem !important;
}
div.step-item:nth-last-child(3) {
  display: none;
}
.iconSucces {
  margin-top: 3rem;
}
.step-item.is-finish.is-active ~ .steps-actions {
  display: none;
}
.btnSigIn {
  width: 17rem;
  margin-top: 2rem;
  background-color: #6d8df3 !important;
  color: #fff !important;
}
.subTitleStart {
  font-size: 20px;
  color: #000000;
  margin-top: 1rem;
}
.button.is-light[disabled] {
  visibility: hidden;
}
</style>
